import { render, staticRenderFns } from "./ResetEmailLandPage.vue?vue&type=template&id=32f98a20&"
import script from "./ResetEmailLandPage.vue?vue&type=script&lang=js&"
export * from "./ResetEmailLandPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports